<app-spinner-overlay></app-spinner-overlay>
<div class="contenitore">
  <div class="titolo-pagina">
    <app-titolo-subtitolo
      [titolo]="'Report VSME'"
      subTitolo="Lo standard volontario per le microimprese, le piccole e le medie imprese (VSME) non
quotate è pubblicato dall'EFRAG ed è accompagnato dalla base delle conclusioni delle
VSME. <br> <br> L'EFRAG non si assume alcuna responsabilità per il contenuto o per eventuali
conseguenze o danni diretti, indiretti o incidentali derivanti dal rispetto dei consigli o
delle linee guida contenute nel presente documento. <br> <br> Le informazioni contenute in
questa pubblicazione non costituiscono una consulenza e non devono essere sostituite
dai servizi di un professionista adeguatamente qualificato."
    ></app-titolo-subtitolo>
  </div>
  <app-lista-tabellare
    #tabella
    [fnCaricamentoDati]="fnCaricamentoDati"
    [colonne]="colonne"
    [filtri]="filtri"
    (bottoniListaClick)="bottoniListaClick($event)"
  >
    <div btnEnd>
      <button mat-flat-button class="primary-button" color="primary" (click)="crea()">
        <!--  *ngIf="this.utenteService.isPermessoAttivo('CREATE_VSME')" -->
        Nuovo
      </button>
    </div>
  </app-lista-tabellare>
</div>
